import { useId } from '@reach/auto-id';
import hashSum from 'hash-sum';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useAsyncDebounce } from 'react-table';

const TableSearchFilter = ({
  data,
  globalFilter,
  i18n,
  id,
  setGlobalFilter,
  ...rest
}) => {
  // We don't want to use globalFilter for the input value for perf reasons
  const [value, setValue] = useState(globalFilter);
  const handleChange = useAsyncDebounce((formValue) => {
    setGlobalFilter(formValue);
  }, 200);
  const tableFilterLabel = i18n.tableFilterLabel();
  const dataHash = hashSum(data);
  const elementId = useId(id);

  useEffect(() => {
    if (value && !globalFilter) setGlobalFilter(value);
  }, [dataHash, globalFilter, setGlobalFilter, value]);

  return (
    <div {...rest} className="mb-4">
      <label htmlFor={elementId}>
        <span className="sr-only">{tableFilterLabel}</span>
      </label>
      <input
        className="table-search-filter"
        id={elementId}
        name={id}
        onChange={(e) => {
          setValue(e.target.value);
          handleChange(e.target.value);
        }}
        placeholder={tableFilterLabel}
        type="search"
        value={value}
      />
    </div>
  );
};

TableSearchFilter.defaultProps = {
  globalFilter: '',
  id: null,
};

TableSearchFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  globalFilter: PropTypes.string,
  i18n: PropTypes.shape({
    tableFilterLabel: PropTypes.func.isRequired,
  }).isRequired,
  id: PropTypes.string,
  setGlobalFilter: PropTypes.func.isRequired,
};

export default TableSearchFilter;
